import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
// Reutilizamos el anillo giratorio del PageSpinner (clase .page-spinner__ring).
import '../PageSpinner/PageSpinner.css';
import './LogoutOverlay.css';

/**
 * Overlay a pantalla completa que BLOQUEA toda la interacción mientras se está
 * cerrando la sesión. Se muestra cuando AuthContext expone `isLoggingOut`, así
 * que cubre por igual el logout desde el header y desde Ajustes. Muestra el
 * texto "Cerrando sesión" traducido al idioma activo.
 */
export function LogoutOverlay() {
  const { isLoggingOut } = useAuth();
  const { t } = useTranslation();
  if (!isLoggingOut) return null;
  return (
    <div className="logout-overlay" role="alert" aria-live="assertive" aria-busy="true">
      <div className="page-spinner__ring" aria-hidden="true" />
      <span className="logout-overlay__label">{t('common.loggingOut')}</span>
    </div>
  );
}
